<template>
    <div class="history-management-view">
      <div class="documentmanagement-header">Player Imported Data</div>
      <div class="tabs flex">
        <div class="tab" :class="`${currentView == 'imports' ? 'active' : ''}`" @click="selectView('imports')">Import History</div>
        <div class="tab" :class="`${currentView == 'player_data' ? 'active' : ''}`" @click="selectView('player_data')">Player Data</div>
      </div>
        <div class="subsidiary-container" v-if="currentView == 'player_data'">
            <div class="subsidiary-content">
                <div class="sub-header" >
                    <h4 class="subsidiary-title">Player List</h4>
                    <button class='w-content' @click="showImportPopup = true">Import Data</button>
                </div>
                <table class="subsidiary-list">
                    <thead>
                    <tr>
                        <th>Id</th>
                        <th>Full Name</th>
                        <th>Date of Birth</th>
                        <th>Address Info</th>
                        <th>Identification</th>
                    </tr>
                    </thead>
                    <tbody v-if="dataList">
                    <tr class="account-list" v-for="(player, index) in dataList" @click="openPlayer(player)">
                        <td>
                            <div class='attachment'> 
                                {{ player.PlayerId }}
                            </div>
                        </td>
                        <td class="user-info"> 
                            <div class="user-name">
                                {{ player.FirstName }} {{ player.LastName }}
                            </div>
                        </td>
                        <td>
                            {{ formatUtcDate(player.DateOfBirth) }}
                        </td>
                        <td> 
                            <div class="details flex gap-5px align-center ">
                                <span v-if="player.Country" :class="`fi fi-${player.Country.toLowerCase()}`"></span>
                                <p>{{ player.Country }}, {{ player.City }}, {{ player.Address }}, {{  player.Zip }}</p>
                            </div>
                        </td> 
                        <td> 
                            <div class="details">
                                <div class="flex gap-5px align-center ">
                                    <span v-if="player.IdentificationCountry" :class="`fi fi-${player.IdentificationCountry.toLowerCase()}`"></span>
                                    <p>{{ player.IdentificationCountry }}, {{ player.IndentificationType }}, {{ player.IdentificationNumber }}</p>
                                </div>
                                <p>Tax number: {{ player.TaxNumber }}</p>
                            </div>
                        </td> 
                        <td>
                        <div class="flex gap-5px justify-end"></div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div v-if="loading" class='no-data-present no-data-presents '>
                    <LoaderItem :size="'50px'"/> Loading
                </div>
                <div class='no-data-present no-data-presents' v-else-if="dataList && dataList.length == 0">
                    Nothing here yet
                </div>
            </div>
        </div>
        <div class="subsidiary-container" v-if="currentView == 'imports'">
            <div class="subsidiary-content">
            <div class="sub-header" >
                <h4 class="subsidiary-title">Imports List</h4>
                <button class='w-content' @click="showImportPopup = true">Import Data</button>
            </div>
            <table class="subsidiary-list">
                <thead>
                <tr>
                    <th>FileName</th>
                    <th>Upload Date</th>
                    <th>Status</th>
                    <th>Records</th>
                </tr>
                </thead>
                <tbody v-if="dataList">
                <tr class="account-list" v-for="(file, index) in dataList">
                    <td>
                        <div class='attachment'>
                            <img src="@/assets/excel-file.svg" class='fileicon'>
                            <div class="filename">
                            <div class="name-of-the-file">{{ file.filename }}</div>
                            <div class="size-of-the-file">{{ Utils.calculateFileSize(file.filesize) }}</div>
                            </div>
                        </div>
                    </td>
                    <td class="user-info"> 
                    <div class="user-name">
                        {{ formatDate(file.uploadDate) }}
                    </div>
                    </td>
                    <td>
                        <div class="flex gap-5px align-center"> 
                            {{ file.importStatus }}
                            <LoaderItem size="30px" v-if="file.importStatus == 'processing'"/> 
                        </div>
                    </td>
                    <td>{{ (+file.importedRows || 0).toLocaleString() }}</td>
                </tr>
                </tbody>
            </table>
            <div v-if="loading" class='no-data-present no-data-presents '>
                    <LoaderItem :size="'50px'"/> Loading
            </div>
            <div class='no-data-present no-data-presents' v-else-if="dataList && dataList.length == 0">
                Nothing here yet 
            </div>
            </div>
        </div>
        <vue-awesome-paginate
            v-if="totalCount > 12"
            class="pagination"
            :total-items="totalCount"
            :items-per-page="12"
            :max-pages-shown="8"
            v-model="currentPage"
            @click="handlePageClick"
        />
        <PopupCover @close="() => showImportPopup = false" v-if="showImportPopup && !showAssociationPopup">
            <PopupBody @close="() => showImportPopup = false" class="preview-popup" style="width: 700px;">
            <template #header>Import Player Data</template>
            <template #body>
                <div class="flex column gap-20 main-table">
                    <div class="explanation flex column gap-10">
                        <div>
                            <p class="header-text text-left">1. Download the and populate it with the data of platform Players</p>
                            <div class='attachment player-import' @click="downloadTemplate()">
                                <img src="@/assets/excel-file.svg" class='fileicon'>
                                <div class="filename">
                                <div class="name-of-the-file">PlayerDataTemplate.csv</div>
                                <div class="size-of-the-file">1Kb</div>
                                </div>
                            </div>
                            <p class="text-left"> - Player Account Id is mandatory and should be unique for each player, it will be used to match the data in the excel conversions later</p>
                            <p class="text-left"> - Include Address information</p>
                            <p class="text-left"> - Include Verification information</p>
                        </div>
                        
                        <p class="header-text text-left">2. Upload Your file here and match he columns</p>
                        <SimpleFIleUpload @file-selected="(file) => associateFile(file)"/>

                        <p class="header-text text-left">3. In all future excel conversions just provide Player Account Id and the rest will be associated atomatically from the most recent Player import</p>
                    </div>
                    
                    <div class="button-section flex gap-10">
                        <button class="button transparent" @click="closePopup">Cancel</button>
                        <button class="button" :disabled="!selectedFile" @click="Associations()">Next</button>
                    </div>
                </div>
            </template>
            </PopupBody>
        </PopupCover>
        <PopupCover @close="() => showAssociationPopup = false" v-if="showAssociationPopup">
            <PopupBody @close="() => showAssociationPopup = false" class="preview-popup association-popup">
            <template #header>Associate Data</template>
            <template #body>
                <div class="flex column gap-20 main-table association-popup-body">
                    <Association 
                        :file="selectedFile" 
                        @importFinished="importFinish()"
                    />
                    <!-- @importSent="importFinish()"     -->

                </div>
            </template>
            </PopupBody>
        </PopupCover>

        <PlyaerInfoView v-if="playerId" :playerId="playerId" @close="closePopup"/>

    </div>
</template>
<script setup>
    import API from '@/api/index.js'
    import Utils from '@/utils';
    import PopupBody from '@/components/PopupBody.vue';
    import PopupCover from '@/components/PopupCover.vue';
    import SimpleFIleUpload from './SimpleFIleUpload.vue';
    import PlyaerInfoView from './PlyaerInfoView.vue';
    import Association from './Association.vue';
    import LoaderItem from './LoaderItem.vue';
    import { ref, onMounted, computed } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import { formatUtcDate } from '@/utils/date_display.js';
    import store from '@/store/index.js';
    
    const router = useRouter();
    const route = useRoute();

    const queryParamView = computed(() => route.query.view || 'imports');

    const playerId = computed(() => route.query.playerId || null);

    const dataList = ref(null);
    const totalCount = ref(null);
    const currentPage = ref(1);
    const props = defineProps(['account_id'])
    const showImportPopup = ref(false);
    const currentView = ref(queryParamView.value);
    const showAssociationPopup = ref(false);
    const selectedFile = ref(null);
    const loading = ref(false);
    const intervalId = ref(null);

    function closePopup(){
        router.push({ query: { view: currentView.value } });
    }
    onMounted(async () => {
        document.title = 'Player Data';
        await doRequest();
    })
  
    // Upload time in the browser's date format (local day)
    function formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' });
    }
 

    function associateFile(file) {
        console.log(file);
        selectedFile.value = file;
    }
    function Associations(){
        showAssociationPopup.value = true;
    }
    function importFinish(){
        showAssociationPopup.value = false;
        showImportPopup.value = false;
        doRequest();
    }
   
   
    const handlePageClick = async (page) => {
      currentPage.value = page;
      await doRequest();
    }
    const selectView = (view) => {
        router.push({ query: { view: view } });
        clearInterval(intervalId.value);
        dataList.value = []
        currentView.value = view;
        totalCount.value = 0;
        currentPage.value = 1;
        doRequest();
    }

    async function downloadTemplate(){
        await API.downloadTemplate('player-data', 'PlayerDataTemplate.csv');
        store.dispatch('addNotification', { text: 'Template downloaded successfully.\nCheck Downloads folder', type: 'success' });
    }
    function openPlayer(player) {
        router.push({ query: { view: currentView.value, playerId: player.PlayerId } });
    }

    async function doRequest() {
        loading.value = true;
        dataList.value = [];
        let data = [];
        if (currentView.value == 'player_data') {
            data = await API.getPlayerList(props.account_id, currentPage.value);
            clearInterval(intervalId.value);
        } else {
            data = await API.getImportList(props.account_id, currentPage.value);
            if (!data.response_data){
                return
            }
            let pendingImports = data.response_data.find(item => ['pending', 'processing'].includes(item.importStatus));
            if (pendingImports) {
                initiateImportStatusCheck();
            } else {
                clearInterval(intervalId.value);
            }

        }
        dataList.value = data.response_data
        totalCount.value = data.totalCount;
        loading.value = false;
    }
    function initiateImportStatusCheck() {
        intervalId.value = setInterval(async () => {
            const data = await API.getImportList(props.account_id, currentPage.value);
            dataList.value = data.response_data
            totalCount.value = data.totalCount;
            if (!data.response_data){
                return
            }
            let pendingImports = data.response_data.find(item => ['pending', 'processing'].includes(item.importStatus));
            if (!pendingImports) {
                clearInterval(intervalId.value);
            }
        }, 4000); // check every 2 seconds
    }
  
  </script>
    
    
    
    <style scoped lang="scss">
  
  
  
    h4 {
      margin: 0;
    }
  
    .subsidiary-content {
      min-width: 100%;
      border: 1px solid #ccc;
      border-radius: 10px;
      width: fit-content;
    }
    .documentmanagement-header {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 20px;
      text-align: left;
      color: black;
    }
    .history-management-view {
      display: flex;
      padding: 20px;
      flex-direction: column;
      max-width: 1350px;
      margin: auto;
    }
    .subsidiary-container {
          width: 100%;
      }
      
      .subsidiary-content {
          min-width: 100%;
          border: 1px solid #ccc;
          border-radius: 10px;
          width: fit-content;
      }
      
      .sub-header {
          border-top-right-radius: 10px;
          border-top-left-radius: 10px;
          padding: 20px;
          padding-left: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: white;
      }
      
      .subsidiary-title {
          display: flex;
          justify-content: space-between;
          color: black;
          font-size: 20px;
      }
      
      .sub-header {
          display: flex;
          justify-content: space-between;
          button {
              width: fit-content;
              padding: 10px;
          }
      }
      .subsidiary-list {
          padding: 20px;
          width: 100%;
          border-collapse: collapse;
          th, td {
              // border: 1px solid #ccc;
              padding: 15px;
              text-align: left;
              border: none;
              padding-left: 15px;
              color: black;
          }
          td {
              padding-top: 0px;
              padding-bottom: 0px;
          }
          th {
              text-align: left;
              border: none;
          }
          tr {
              border-top: 1px solid #ccc;
          }
          tbody {
              tr {
                  cursor: pointer;
                  td {
                      background: white;
                  }
  
                  &:last-child {
                      td {
                          &:first-child {
                              border-bottom-left-radius: 10px;
                          }
                          &:last-child {
                              border-bottom-right-radius: 10px;
                          }
                      }
                  }
                  &:hover {
                      td {
                          background: #f9f9f9;
                      }
                  }
              }
          }
      }
      
      .error-button {
          background: #f04f4f;
          color: black;
          border: 1px solid #ffcccc;
      }
      .error-container {
    height: 50vh;
    background-color: #f8d7da; /* Light red background color */
    color: #721c24; /* Dark red text color */
    border: 1px solid #f5c6cb; /* Border color */
    padding: 15px;
    overflow-y: auto;
    margin: 10px 0;
    border-radius: 5px;
    text-align: left;
  }
  .error-message {
    font-weight: bold;
  }
  .error-header {
    margin-top: 0;
  }
  
  .message-attachments {
      display: flex;
      flex-direction: column;
      gap: 1rem;
  }
  .size-of-the-file {
      font-size: 0.8rem;
      color: rgb(116 119 127);
  }
    .details {
        :deep(p) {
            margin: 0;
        }
        p {
            margin: 0;
        }
    }
  .name-of-the-file {
      display: flex;
      align-items: center;
      color: black;
      font-size: 1rem;
  
      text-align: left;
      overflow: hidden;
      //text-wrap: nowrap;
      text-overflow: ellipsis;
  }
  .fileicon {
      width: 40px;
      height: 40px;
  }
  .hoverable {
      cursor: pointer;
      text-decoration: underline;
      &:hover {
          text-decoration: none;
      }
  }
  
  .attachment {
      border-radius: .5rem;
      border-width: 1px;
      -moz-column-gap: .5rem;
      column-gap: .5rem;
      padding: .8rem;
      padding-left: 0;
      display: flex;
      align-items: center;
  }
    .player-import {
        background-color: white;
        width: fit-content;
        cursor: pointer;
        text-align: left;
        padding: 10px;
        &:hover {
            background-color: #fcfcfc;
        }
    }
    
  .pagination[class] {
    margin: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  
    &:deep(button) {
      padding: 10px 20px;
    }
    &:deep(.active-page) {
      // background-color: var(--button-hover-color-blue);
      background: #00408985;
      color: white;
    }
  }
  .tabs {
    display: flex;
    margin-bottom: 20px;
    border-bottom: 3px solid rgb(224 226 236);
    width: fit-content;
    .tab {
      padding: 10px 20px;
      cursor: pointer;
      color: rgb(116 119 127);
      font-size: 16px;
      font-weight: 600;
      margin-bottom: -3px; 
      &.active {
        color: rgb(0 115 239);
        border-bottom: 3px solid rgb(0 115 239);
      }
    }
  }
  .no-data-present {
    height: 530px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

.header-text {
    color: black;
    font-weight: bolder;
    span {
        color: rgb(0 115 239);
        cursor: pointer;
        text-decoration: underline;
        &:hover {
            text-decoration: none;
        }
    }
}
.association-popup {
    width: 96vw;
    height: 94vh;
}
.association-popup-body {
    flex: 1;
    min-height: 0;
}
.explanation {
    gap: 10px;
    p {
        margin: 0;
    }
}

</style>